// Generated by genversion.
export const name = 'sibelga-portal-frontend';
export const version = '1.6.7';
